const prefix = 'nxt';
const iconName = 'phoneOutbound';
const width = 1024;
const height = 1024;
const ligatures = [];
const unicode = '';
const svgPathData = [
  'M968.002 659.992l-204.002-85.993c-9.999-4.001-22.001-8.002-36.001-8.002-27.999 0-54.001 13.999-69.997 33.996l-65.996 80.003c-106.006-58.002-190.002-141.998-248.002-248.004l80.002-65.996c19.997-15.999 33.996-42 33.996-69.999 0-14-4.001-26-8.002-36l-85.997-203.999c-13.999-32-48-55.998-86-55.998-6 0-12 2.001-20 3.999l-187.999 42c-39.999 9.999-69.999 45.999-69.999 89.999 0 491.993 397.996 889.991 887.992 887.994 44.002 0 80.003-30.003 90.001-69.997l41.998-187.998c2.004-8.002 4.001-14.007 4.001-20.004 0-37.997-23.998-72.001-55.998-86zM883.997 929.99c-433.998-1.997-785.993-355.991-787.992-789.992l179.999-42 83.999 195.998-136 112c93.999 197.997 196 299.993 393.997 393.997l112.002-136 196 84.005-42.005 181.992z',
  'M701.698 117.364l106.064-11.343-212.405 263.283c-10.049 12.452-8.331 28.524 4.125 38.566l21.343 17.225c11.564 9.326 28.526 8.331 38.568-4.125l212.412-263.283 10.452 105.349c1.551 14.463 15.776 25.946 30.245 24.398l27.319-2.923c14.467-1.546 25.944-15.778 24.401-30.242l-24.092-217.672c-0.833-15.353-14.175-26.117-29.352-23.681l-217.847 22.486c-14.46 1.546-25.944 15.778-24.401 30.242l2.926 27.32c1.543 14.463 15.776 25.946 30.245 24.398z',
];

const definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [width, height, ligatures, unicode, svgPathData],
};

const nxtPhoneOutbound = definition;

export { definition, nxtPhoneOutbound, prefix, iconName, width, height, ligatures, unicode, svgPathData };
